import React from 'react';

import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const LicenseSkeleton = () => (
    <FormSectionSkeleton labelWidth={70}>
        <Group alignItems="start" gap="l">
            <FormItemSkeleton labelWidth={70}>
                <div style={{width: 300}}>
                    <Group direction="v" gap="s">
                        <SkeletonItem width={300} height={32}/>
                        <SkeletonItem width={300} height={32}/>
                    </Group>
                </div>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={70}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={70}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
        </Group>
    </FormSectionSkeleton>
);
